import { DETAIL_PAYMENT_PACKAGE } from "..";
import { apiInstance } from "../config/apiInstance";

export type GetDetailPaymentPackageParams = {
  consecutive: string;
  size?: number;
  page?: number;
};

export type DetailPaymentPackageItem = {
  id: number;
  consecutive: string;
  conceptCode: string;
  conceptName: string;
  employerIdNumber: string;
  employerName: string;
  totalValue: number;
  operatingIndicator: string;
  costCenterCode: string;
  budgetCertificate: string;
  budgetRegistration: string;
};

export type GetDetailPaymentPackageResponse = {
  content: DetailPaymentPackageItem[];
  totalElements: number;
  number: number;
  size: number;
  contentSize: number;
};

export const getDetailPaymentPackage = async (
  params: GetDetailPaymentPackageParams,
): Promise<GetDetailPaymentPackageResponse> => {
  const response = await apiInstance.get<GetDetailPaymentPackageResponse>(
    DETAIL_PAYMENT_PACKAGE,
    {
      params: {
        ...params,
      },
    },
  );
  return response.data;
};
